import { render, staticRenderFns } from "./PartnerViewSmall.vue?vue&type=template&id=a46c60cc&scoped=true"
import script from "./PartnerViewSmall.vue?vue&type=script&lang=js"
export * from "./PartnerViewSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46c60cc",
  null
  
)

export default component.exports